import script from "./PaymentInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentInformation.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentInformation.vue?vue&type=style&index=0&id=89a6d2b6&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a6d2b6"]])

export default __exports__